export const AIS_PHONE = '+971 4 5771354';
export const AIS_EMAIL = 'info@artinspace.art';
export const AIS_ADDRESS = 'Boulevard Crescent retail 1 - Sheikh Mohammed bin Rashid Blvd - Downtown Dubai - Dubai';
export const AIS_INSTAGRAM_URL = 'https://www.instagram.com/artinspace.gallery';
export const AIS_INSTAGRAM_NAME = 'artinspace.gallery';
export const AIS_TWITTER_URL = 'https://twitter.com/ArtInSpace_art';
export const AIS_TWITTER_NAME = '@artinspace_art';
